import React from 'react';
import ProductCard from './ProductCard';

const HorizontalProductList = ({ products = [] }) => {
  if (!products || products.length === 0) {
    return (
      <div className="flex items-center justify-center py-8 text-gray-500">
        <p>No products available</p>
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="flex gap-3 overflow-x-auto pb-4 scrollbar-hide">
        {products.map((product) => (
          <div key={product.id} className="w-[170px] min-w-[170px] flex-shrink-0">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent" />

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default HorizontalProductList;
